module.exports = __webpack_public_path__ + "img/asset-plug.4e346fd1.svg";